import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../../cra/src/styling/breakpointsMinWidth';

import Categories from './shared/categories';
import SearchBar from './shared/searchBar';

const FilterSection = styled.section`
  margin: 28px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 12px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin: 28px 0;

    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 24px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(12, 1fr);
  }
`;

const Wrap = styled.div`
  grid-column: 1/-1;

  padding: 16px 0;

  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/-2;

    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 24px;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-template-columns: repeat(10, 1fr);
  }

  @media ${breakpointsMinWidth.desktopLg} {
    grid-column: 3/-3;

    grid-template-columns: repeat(8, 1fr);
  }
`;

const Filter = ({
  activeCategory,
  categories,
  changeCategory,
  setSearchedValue,
}) => (
  <FilterSection>
    <Wrap>
      <SearchBar setSearchedValue={setSearchedValue} />
      <Categories
        activeCategory={activeCategory}
        data={categories}
        changeCategory={changeCategory}
      />
    </Wrap>
  </FilterSection>
);

export default Filter;
